/**
 * Transform typical string key into a presentable format.
 */
export function keyToLabel(key: string): string {
  if (key === '') {
    return '';
  }

  const words = key
    // split camel/pascal cased words
    .replace(/([a-z\d])([A-Z])/g, '$1 $2')
    // remove common delimiters
    .replace(/[-_]/g, ' ')
    .split(' ');
  // ensure all words are upper cased
  return words.map((w) => w.charAt(0).toUpperCase() + w.slice(1)).join(' ');
}
